import { dollarsToNum } from "@oneethos/shared"
import { LoanCalculations } from "@oneethos/shared"
import { useMemo } from "react"
import { useAppState } from "."
import { ConsumerAppFormData } from "../pages/consumerApplicationForm"

export const useConsumerCalcs = (formData: ConsumerAppFormData) => {
  const { tenant } = useAppState()

  const product = tenant.config.products.find(p => p.id === formData.productId)
  const loanTermInYears = LoanCalculations.calculateLoanTermInYears(product.term)

  let rate = (
    formData.useAutoDebit === 'no'
      ? product.interestRateWithoutAutopay
      : product.interestRateWithAutopay
  )

  const amortization = useMemo(() => {
    const closingCosts = LoanCalculations.estimatedClosingCosts(
      dollarsToNum(formData.loanAmount),
      formData.installationAddress?.state,
      formData.projectType,
      undefined,
      LoanCalculations.feesForApplicationOrQuote(
        formData.fees,
        undefined,
        formData.projectType,
        true
      )
    )

    return LoanCalculations.getPaymentAndAmortizationSchedule(
      product.term,
      dollarsToNum(formData.loanAmount),
      closingCosts,
      rate,
      product.interestOnlyPeriod
    )
  }, [
    formData.useAutoDebit,
    formData.loanAmount,
    formData.installationAddress?.state,
    formData.projectType,
    product,
    formData.fees,
    rate,
  ])

  return { loanTermInYears, rate, amortization }
}
